// extracted by mini-css-extract-plugin
export default {"img":"CountdownSection_img__eusM5"};